/* ksv-ship-attr.js（2026-10-29）複数お届け先の送り状（B2クラウド・e飛伝Ⅲ）用の情報を、注文の追加情報「_送り状」に残す
   ・Shopify の「注文をエクスポート」の CSV には、商品ごとの入力欄（どの商品をどのお届け先へ送るか）が出ない。
     そこで、入力画面が「お支払いへ進む」でカートの属性を書くとき（/cart/update.js）に、お届け先ごとの
     宛名・郵便番号・住所・電話・お届け日・時間帯・商品（品名・数・温度帯）をまとめて JSON で足す。
   ・「複数お届け先の送り状づくり」のページが、エクスポートの Note Attributes からこれを読み、お届け先ごとに1行の CSV を作る。
   ・1か所の注文では空にする（Shopify のお届け先がそのまま送り状の宛先になるため）。
   ・入力画面の本体（ksv-order.js）は変えていない。このファイルを読み込まなければ（snippets/ksv-lead.liquid の1行を消せば）元どおり。
   ・何か失敗しても、ご注文の流れは止めない（足さずにそのまま進む）。 */
(function () {
  if (window.__ksvShipAttr) return; window.__ksvShipAttr = true;
  var of = window.fetch; if (!of) return;
  function digits(s) { return String(s || '').replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); }).replace(/[^0-9]/g, ''); }
  function zipFmt(z) { return digits(z).replace(/^([0-9]{3})([0-9]{4})$/, '$1-$2'); }
  function addrOf(x) { var a = String(x.addr || '').trim(), pc = String(x.pref || '') + String(x.city || ''); if (pc && a.indexOf(pc) === 0) a = a.slice(pc.length); else if (x.city && a.indexOf(x.city) === 0) a = a.slice(String(x.city).length); return a.replace(/^[\s　]+/, '') || String(x.addr || '').trim(); }
  function title(t) { return String(t || '').replace('【配送専用】', '').split('～')[0].trim(); }
  function build(attrs, cart) {
    var recs = JSON.parse(attrs['_ms_recipients']), own = {};
    try { own = JSON.parse(attrs['_ms_orderer'] || '{}') || {}; } catch (e) {}
    return recs.map(function (r) {
      var a = r.kind === 'self' ? own : r, its = [];
      (cart.items || []).forEach(function (it) {
        var p = it.properties || {};
        if (String(p['_お届け先ID'] || '') !== String(r.id) || !p['_温度帯']) return; /* 送料・カード・添えるものは数えない */
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        its.push({ t: title(it.product_title), v: vt, q: it.quantity, temp: p['_温度帯'], s: p['_夏季クール'] ? 1 : 0 });
      });
      var name = r.name || ((a.last || '') + ' ' + (a.first || '')).trim();
      return { id: r.id, name: name, zip: zipFmt(a.zip), pref: a.pref || '', city: a.city || '', addr: addrOf(a), tel: digits(a.tel), date: r.date || '', time: r.time && r.time !== '指定なし' ? r.time : '', items: its };
    });
  }
  window.fetch = function (url, opt) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/update(\.js)?$/.test(u.split('?')[0]) && opt && opt.method === 'POST' && typeof opt.body === 'string') {
        var body = JSON.parse(opt.body), at = body && body.attributes;
        if (at && Object.prototype.hasOwnProperty.call(at, '_ms_recipients')) {
          if (!at['_ms_recipients']) { at['_送り状'] = ''; opt = Object.assign({}, opt, { body: JSON.stringify(body) }); return of.call(this, url, opt); }
          var self = this;
          return of.call(window, '/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { at['_送り状'] = JSON.stringify(build(at, cart)); })
            .catch(function () {})
            .then(function () { return of.call(self, url, Object.assign({}, opt, { body: JSON.stringify(body) })); });
        }
      }
    } catch (e) {}
    return of.apply(this, arguments);
  };
})();
